__turbopack_context__.v({
  "checkbox": "CheckBox-module-scss-module__7u0jHG__checkbox",
  "checkboxLabel": "CheckBox-module-scss-module__7u0jHG__checkboxLabel",
});
